import React, {Fragment} from 'react';
import {MainHeader} from 'presentation/components/MainHeader';
import {Navigate, useNavigate} from 'react-router-dom';
import {HomeEnum} from 'presentation/constants';
import {AlertInfo, MainFooter, StyledGrid} from 'presentation/components';
import {useAccountInformation, useMediaQueries} from '../hooks';
import {Box, Card, Divider, Stack, Typography, useTheme} from '@mui/material';
import {BEFORE_DATE_ITEMS} from './constants';
import Icon from 'presentation/icons';
import {useAccountDataStore} from '../store/useAccountDataStateStore';
import {translations} from 'presentation/translations-new';

const {
	title,
	alert,
	beforeDate,
	afterDate,
	afterDateItems: {totalAccess},
} = translations['pt-br'].privateFlow.home.earlyAccess;
const {beneficiaryPlan, planNumber} = translations['pt-br'].commons;

export function EarlyAccess() {
	const navigate = useNavigate();
	const theme = useTheme();
	const {isMobile} = useMediaQueries();
	const {beneficiary} = useAccountDataStore(store => store.accountData);
	const {isEarlyAccess} = useAccountInformation();

	function handleBack() {
		navigate(HomeEnum.HOME_PAGE);
	}

	if (!isEarlyAccess) {
		return <Navigate to={HomeEnum.HOME_PAGE} replace />;
	}

	return (
		<Fragment>
			<MainHeader title={title} handleBack={handleBack} hideProfileMenu />
			<AlertInfo.Root sx={{margin: isMobile ? '16px 16px 0 16px' : 0}}>
				<AlertInfo.Description>
					{alert.line1} {beneficiary.dtAdesaoC}. {alert.line2}
				</AlertInfo.Description>
			</AlertInfo.Root>
			<StyledGrid.Root p={isMobile ? 2 : 4} direction="row">
				<StyledGrid.Item sm={12} md={8} lg={8}>
					<Card elevation={0} sx={{padding: 2}}>
						<Typography variant="body1">{beforeDate}</Typography>
						<Stack p={2}>
							{BEFORE_DATE_ITEMS.map((item, index) => (
								<Fragment key={index}>
									<Typography variant="body1">{item.title}</Typography>
									<Typography variant="body2" color="textSecondary" mb={1}>
										{item.description}
									</Typography>
								</Fragment>
							))}
						</Stack>
						<Divider />
						<Typography variant="body1" mt={1.5}>
							{afterDate}
						</Typography>
						<Stack p={2}>
							<Typography variant="body1">{totalAccess.title}</Typography>
							<Typography variant="body2" color="textSecondary" mt={1}>
								{totalAccess.description}
							</Typography>
						</Stack>
					</Card>
				</StyledGrid.Item>
				<StyledGrid.Item sm={12} md={4} lg={4}>
					<Card elevation={0} sx={{padding: 2}}>
						<Typography variant="body2" fontWeight="600" color="textSecondary" mb={1}>
							{beneficiaryPlan}
						</Typography>
						<Stack direction="row" alignItems="center" gap={1} mb={1}>
							<Icon name="account-circle-filled" color={theme.palette.primary.main} />
							<Typography variant="body1">{beneficiary.nmUsuario}</Typography>
						</Stack>
						<Stack direction="row" gap={1}>
							<Icon name="hapvida-logo" color={theme.palette.primary.main} />
							<Stack>
								<Typography variant="body1">{beneficiary.nmPlano}</Typography>
								<Typography variant="body1" color="textSecondary">
									{planNumber}: {beneficiary.nuContrato}
								</Typography>
							</Stack>
						</Stack>
					</Card>
				</StyledGrid.Item>
			</StyledGrid.Root>

			<Box mt="auto">
				<MainFooter />
			</Box>
		</Fragment>
	);
}
